import { ChartColumn, History, House, type LucideIcon, Settings } from 'lucide-react';
import type { ReactElement } from 'react';
import { NavLink } from 'react-router';

import { routePaths } from '../../app/route-paths.js';
import styles from './PrimaryNav.module.css';

interface NavItem {
    to: string;
    label: string;
    icon: LucideIcon;
    end?: boolean;
}

const items: readonly NavItem[] = [
    { to: routePaths.today, label: 'Today', icon: House, end: true },
    { to: routePaths.history, label: 'History', icon: History },
    { to: routePaths.insights, label: 'Insights', icon: ChartColumn },
    { to: routePaths.settings, label: 'Settings', icon: Settings },
];

/**
 * Primary navigation. Rendered once; CSS switches between a fixed bottom bar and a sidebar.
 * `NavLink` sets `aria-current="page"` on the active item.
 */
export function PrimaryNav(): ReactElement {
    return (
        <nav aria-label="Primary" className={styles.nav}>
            <ul className={styles.list}>
                {items.map(({ to, label, icon: Icon, end }) => (
                    <li key={to} className={styles.item}>
                        <NavLink
                            to={to}
                            end={end ?? false}
                            className={({ isActive }) =>
                                [styles.link, isActive ? styles.active : undefined]
                                    .filter(Boolean)
                                    .join(' ')
                            }
                        >
                            <Icon size={22} strokeWidth={1.75} aria-hidden="true" />
                            <span className={styles.label}>{label}</span>
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
}
